// @flow

import { useTranslator } from '@gandi/translate';
import { Base, Heading } from '@gandi/ui';

import styles from './TechnicalPoints.scss';

export function TechnicalPoints(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <Base marginBottom="base" align="center">
      <Heading flexJustifyCenter as="h3" fontSize="s">
        {__('How our suggestions are made')}
      </Heading>
      <Base tagName="p" color="light" className={styles.info}>
        {__(
          'Domain name suggestions are generated based on the following criteria: availability, location, the best deals, relevance, and occasionally partner promotions.',
        )}
      </Base>
    </Base>
  );
}
